import Popup from "reactjs-popup";
import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import { useState } from "react";
import {
  useActive2faViaSms,
  useConfirmOtp2faViaSms,
} from "../../lib/queries/queriesAndMutations";
import Loader from "../../shared/Loader";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import RadioBtn from "../../shared/RadioBtn";

const ActiveSmsModalBtn = ({ feildIsActive, onFactorSetiingIsActive }) => {
  const [code, setCode] = useState("");
  const [showTooltip, setShowTooltip] = useState(
    localStorage.getItem("sms-tooltip") === "open"
  );

  const { mutateAsync: activeViaSms } = useActive2faViaSms("");
  const { mutateAsync: confirmOtp, isPending } = useConfirmOtp2faViaSms("");
  const queryClient = useQueryClient();

  const handleSendSms = async (active) => {
    localStorage.setItem("sms-tooltip", "open");
    setShowTooltip(true);
    //console.log("handleSendSms run");
    try {
      const response = await activeViaSms(active);
    } catch (error) {
      console.log({ error });
    }
  };
  const handleConfirmOtp = async ({ close, feildIsActive }) => {
    try {
      const response = await confirmOtp({ otp: code, active: !feildIsActive });
      if (response.status === 200) {
        toast.success("عملیات موفق");
        queryClient.invalidateQueries({ queryKey: ["getProfile"] });
        setCode("");

        close();
      }
      //console.log({ response });
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <Popup
      onOpen={() => handleSendSms(!feildIsActive)}
      trigger={
        feildIsActive ? (
          <RadioBtn checked={true} onClick={() => {}} />
        ) : onFactorSetiingIsActive ? null : (
          <RadioBtn checked={false} onClick={() => {}} />
        )
      }
      onClose={() => {
        localStorage.setItem("sms-tooltip", "close");
      }}
      open={showTooltip}
      modal
      nested
    >
      {(close) => (
        <div
          className="modal-wrapper "
          dir="rtl"
        >
          <p className="text-[#37393b]  text-[14px] font-semibold">
            لطفا کد تایید ارسال شده را جهت فعالسازی رمز عبور دو مرحله ای با
            ارسال پیامک وارد نمایید
          </p>
          <div className="w-full flex justify-center" dir="ltr">
            <OTPInputField
              value={code}
              handleChange={setCode}
              styleObject={{ backgroundColor: "#F0F0F0" }}
              numOfInputs={6}
            />
          </div>
          <div className="flex mr-auto gap-1 mt-8">
            <button
              onClick={close}
              className="secondary-btn"
              disabled={isPending}
            >
              انصراف
            </button>
            <button
              onClick={() => handleConfirmOtp({ close, feildIsActive })}
              className="primary-btn"
              disabled={isPending}
            >
              {isPending ? (
                <div className="w-8 h-8 mx-auto">
                  <Loader />
                </div>
              ) : (
                "تایید کد"
              )}
            </button>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default ActiveSmsModalBtn;
